function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M451.169,244.282c16.637-106.421-72.142-213.687-188.71-227.009 c-1.451-0.166-2.904-0.321-4.358-0.466c-81.45-8.09-155.901,54.127-177.189,101.581C59.624,165.841,3.913,210.985,24.563,298.94 c20.649,87.955,76.747,134.819,208.273,148.689c131.526,13.87,155.793-23.747,190.708-105.923 C435.643,313.23,445.705,279.23,451.169,244.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M451.169,244.282c16.637-106.421-72.142-213.687-188.71-227.009 c-1.451-0.166-2.904-0.321-4.358-0.466c-81.45-8.09-155.901,54.127-177.189,101.581C59.624,165.841,3.913,210.985,24.563,298.94 c20.649,87.955,76.747,134.819,208.273,148.689c131.526,13.87,155.793-23.747,190.708-105.923 C435.643,313.23,445.705,279.23,451.169,244.282z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Road"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M61.402,260.797 c0,0,125.269-79.245,286.176,21.419"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M211.474,269.779 c-8.594-7.059,16.973-34.254,16.973-34.254c-11.196-2.009-9.678-1.603-9.678-1.603s-29.095,28.097-29.402,44.057 c-0.307,15.96,44.396,30.901,44.396,30.901l16.771-7.363l14.642-5.43C265.176,296.087,220.068,276.839,211.474,269.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M187.649,339.134 c0,0,107.459-102.101,284.876-34.664"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M477.001,434.47 c0,0-51.445-53.179-137.572-83.237c-86.127-30.058-230.057-8.671-292.485,34.682"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M146.573,409.994c-10.465,3.676-19.744,6.845-28.029,9.586 c29.618,13.846,67.098,23.072,114.292,28.049c10.42,1.099,20.162,1.872,29.295,2.328c60.236-43.992,87.806-94.973,87.806-94.973 c2.058,0.667-33.549-14.993-73.707-16.379C276.229,338.604,226.01,382.09,146.573,409.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M183.067,492.443 c115.564-42.576,166.869-137.46,166.869-137.46c2.058,0.667-33.549-14.993-73.707-16.379c0,0-50.22,43.486-129.656,71.39 c-88.022,30.92-93.016,26.357-114.213,26.357"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M374.678,365.273 c18.723,7.566,39.773-10.795,38.277-30.357c-1.456-19.031-25.259-29.285-40.19-35.56c-39.631-16.656-65.477-13.785-65.477-13.785 s40.195-7.465,82.118-2.299c36.296,4.472,74.062,26.43,89.426,60.725c8.263,18.446,8.592,38.926,7.012,58.736 c-1.787,22.41-8.842,31.738-8.842,31.738S426.432,393.795,374.678,365.273z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Flags"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 307.953,
    y1: 291.394,
    x2: 304.089,
    y2: 99.286
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 329.693,123.678 347.641,133.876 341.522,142.615 345.992,153.943 322.101,146.451  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 328.794,143.943 322.101,146.451 329.693,123.678  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 304.85,102.363 330.953,113.47 328.794,143.943 305.495,135.506  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 210.264,
    y1: 237.428,
    x2: 208.018,
    y2: 156.791
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 218.845,166.948 226.606,172.139 223.873,174.859 226.725,179.147 215.732,176.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 218.534,175.458 215.732,176.533 218.845,166.948  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 208.347,158.08 219.433,162.889 218.534,175.458 208.725,171.992  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 277.613,
    y1: 248.108,
    x2: 275.959,
    y2: 195.828
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 283.93,203.305 289.643,207.126 287.631,209.129 289.731,212.285 281.639,210.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 283.701,209.57 281.639,210.361 283.93,203.305  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 276.202,196.777 284.362,200.317 283.701,209.57 276.48,207.018  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 354.82,
    y1: 369.71,
    x2: 357.056,
    y2: 49.761
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 390.595,83.426 414.857,100.872 405.822,109.28 414.482,123.305 383.693,119.319  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 400.957,117.727 383.693,119.319 390.595,83.426  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 357.97,53.921 404.164,77.058 400.957,117.727 357.674,98.466  "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M217.696,31.784 c-3.666,3.477-5.832,7.123-7.997,9.289c-4.749,4.749-9.954-4.353-19.813-1.477c-13.116,3.826-12.636,12.558-15.011,14.14 c-2.374,1.583-14.246-4.749-19.786-1.583c-5.54,3.166-9.497,10.289-9.497,10.289h90.189"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M245.918,62.441 h55.589c0,0-3.166-13.455-11.872-16.62c-8.706-3.166-11.575,4.96-14.281,5.975c-2.707,1.015-3.131-1.226-3.131-1.226 s-11.872-29.284-32.449-27.701c-6.907,0.531-12.031,2.222-15.97,4.413"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M418.329,169.496 c-2.41,2.079-3.723,4.378-5.037,5.691c-2.623,2.623-5.498-2.404-10.944-0.816c-7.245,2.113-6.98,6.937-8.292,7.811 c-1.311,0.874-7.869-2.623-10.929-0.874c-3.06,1.749-5.246,5.683-5.246,5.683h57.94"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M440.552,186.991 h23.453c0,0-1.749-7.432-6.558-9.181c-4.809-1.749-6.394,2.74-7.889,3.3c-1.495,0.561-1.729-0.677-1.729-0.677 s-6.558-16.175-17.924-15.301c-2.799,0.215-5.068,0.775-6.938,1.536"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M258.969,209.162 c0,0-3.844-9.482-10.507-8.97c-6.663,0.512-8.201,4.357-9.738,5.894c-1.538,1.538-3.223-1.409-6.415-0.478 c-4.247,1.239-4.092,4.066-4.861,4.579c-0.769,0.513-4.613-1.538-6.407-0.513c-1.794,1.025-3.075,3.332-3.075,3.332h50.486 c0,0-1.025-4.357-3.844-5.382s-3.748,1.606-4.624,1.935C259.107,209.888,258.969,209.162,258.969,209.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M84.167,133.773 c0,0-3.844-9.482-10.507-8.97c-6.663,0.512-8.201,4.357-9.738,5.894c-1.538,1.538-3.223-1.41-6.416-0.478 c-4.247,1.239-4.092,4.066-4.861,4.579c-0.769,0.512-4.613-1.538-6.407-0.513c-1.794,1.025-3.075,3.332-3.075,3.332h50.486 c0,0-1.025-4.357-3.844-5.382s-3.748,1.606-4.624,1.935C84.304,134.498,84.167,133.773,84.167,133.773z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M152.777,105.949c0,0,2.283,6.05,2.74,9.132c0.457,3.082,1.739,4.748,1.396,5.661c-0.342,0.913-1.484,2.968-1.484,3.653 c0,0.685,2.028,6.096,2.941,8.037c0.913,1.941-1.712,2.511-2.511,3.653c-0.799,1.142-1.027,3.767-1.37,7.077 c-0.342,3.31,0.685,5.137-0.114,6.849c-0.799,1.712-5.936,1.941-8.105,1.37c-2.169-0.571-3.196-1.598-3.196-1.598l-0.685,2.854 c0,0-5.365-4.224-10.844-6.621c-5.479-2.397-14.497-4.794-14.497-4.794l0.571-6.392c0,0-6.05-9.018-8.447-16.552 c-2.397-7.534,1.941-16.095,4.452-19.406c2.511-3.31,14.954-5.822,21.346-5.936c6.392-0.114,16.552,4.794,17.008,4.909 c0.457,0.114,4.338-0.913,4.452,0.571c0.114,1.484-0.913,3.425-0.913,3.425s4.908-2.283,4.452,0.342 C159.512,104.808,153.805,106.291,152.777,105.949z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#263238"
    },
    cx: 153.945,
    cy: 124.457,
    rx: 0.65,
    ry: 1.951
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M155.819,120.233 c0,0-0.91-1.431-2.602,0.39"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M154.375,150.011c0.799-1.712-0.228-3.539,0.114-6.849c0.342-3.31,0.571-5.936,1.37-7.077c-2.283-0.799-6.963,2.626-7.534,1.826 c-0.571-0.799-1.027-15.068-0.685-17.237c0.342-2.169,3.31-2.169,4.566-4.909c1.256-2.74-2.968-5.822-3.196-7.648 s3.767-2.169,3.767-2.169c1.027,0.342,6.735-1.142,7.192-3.767c0.456-2.625-4.452-0.342-4.452-0.342s1.027-1.94,0.913-3.424 c-0.114-1.484-3.995-0.457-4.452-0.571c-0.457-0.114-10.616-5.022-17.008-4.908c-6.392,0.114-18.835,2.625-21.346,5.936 c-2.511,3.31-6.849,11.872-4.452,19.405c2.044,6.424,6.731,13.906,8.072,15.978c0.567,0.37,1.013,0.616,1.289,0.688 c2.169,0.571,6.735,1.826,12.442,0.799c5.708-1.027,10.274-3.082,9.475-4.68c-0.799-1.598-1.256-8.219,0.571-11.301 s3.881,1.598,3.424,7.191c-0.457,5.593-1.712,9.132-2.055,12.671c-0.342,3.539,0.685,10.159,0.685,10.159 s1.027,1.027,3.196,1.598C148.439,151.952,153.576,151.723,154.375,150.011z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M143.853,151.58 c0,0,0.52-2.341-8.585-6.634s-18.73-6.113-19.901-5.593c-1.171,0.52-2.471,2.992-2.471,2.992s9.625,1.561,17.56,5.593 c7.934,4.032,14.698,7.544,14.698,7.544L143.853,151.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M148.926,157.953 c0,0-1.171-2.992-5.333-5.073c-4.162-2.081-8.528-6.655-25.494-10.406c-3.215-0.711-4.292-0.52-5.203-0.13 s-3.512,2.862-4.683,4.683c-1.171,1.821-1.171,1.821-1.171,1.821s11.056-0.13,18.73,2.211c7.674,2.341,25.494,9.235,25.494,9.235 L148.926,157.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M185.946,286.665 c0,0-4.001,3.385-2.924,6.001c1.077,2.616,3.385,6.463,3.385,6.463l1.693-1.847c0,0-2.308-5.232-1.847-6.001 c0.462-0.769,11.541-7.232,11.541-7.232l3.232,6.771l1.693-1.385c0,0-2.77-7.078-3.847-7.694 C197.795,281.125,188.716,283.587,185.946,286.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M188.408,269.892 c0,0,10.156,10.002,10.771,10.618c0.616,0.616,1.077,2.924,0.616,4.155c-0.462,1.231-9.079,8.002-10.771,8.771 c-1.693,0.769-2.616-1.539-2.77-2.154c-0.154-0.616-0.923-2.308-1.077-2.77c-0.154-0.462-4.309-5.078-5.54-8.617 c-1.231-3.539-1.385-4.924-1.385-4.924L188.408,269.892z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M67.106,277.043 c0,0,2.087,4.815,2.568,5.297c0.482,0.482,5.136,5.457,5.618,6.741c0.482,1.284,0,5.618,1.766,8.828 c1.766,3.21,0.642,4.494-1.284,3.852c-1.926-0.642-3.371-4.494-3.371-4.494s1.766,6.42,2.087,7.544 c0.321,1.124,5.136,2.408,4.334,3.531c-0.803,1.124-9.31,1.605-11.236,1.445c-1.926-0.16-5.457-4.655-6.581-5.297 c-1.124-0.642-4.013-12.841-4.815-15.088c-0.803-2.247-2.087-12.038-2.087-12.038L67.106,277.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M65.34,287.315 c0,0,0.482,4.976-0.482,7.544c-0.963,2.568-0.803,5.457-0.803,5.457s1.766,4.494,2.408,4.976 c0.642,0.482,7.704,0.963,6.581,2.087"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M145.104,446.258 c0,0,4.155,3.166,6.133,4.353c1.979,1.187,10.486,1.978,11.08,3.561c0.594,1.583-0.901,3.072-1.728,3.81 c-0.914,0.817-6.78,3.004-11.33,2.521c-1.814-0.193-3.363,0.198-4.748,0.396c-1.385,0.198-11.08,1.385-15.235,1.781 c-4.155,0.396-5.144-2.968-5.342-7.123c-0.198-4.155,0-8.903,0-8.903l16.62-2.374L145.104,446.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M150.674,457.867 c-3.574-0.231-6.111,0.692-15.911,1.153c-5.547,0.261-8.727-0.032-10.445-0.335c0.583,2.564,1.925,4.284,4.959,3.995 c4.155-0.396,13.85-1.583,15.235-1.781c1.385-0.198,2.934-0.588,4.748-0.396c4.55,0.483,10.416-1.704,11.33-2.521 c0.649-0.58,1.694-1.623,1.834-2.809C159.344,457.208,153.518,458.051,150.674,457.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M80.402,283.492 c0,0,4.353,15.828,9.695,29.678c5.342,13.85,12.267,34.624,12.267,34.624l4.946,30.074c0,0,0.791,15.037,3.561,26.117 c2.77,11.08,13.459,44.648,13.459,44.648s3.759,1.583,8.706,1.385c4.946-0.198,12.069-3.759,12.069-3.759s0.594-4.551,0.198-6.529 c-0.396-1.979-2.77-2.968-3.363-4.551c-0.594-1.583-8.117-47.814-8.117-47.814s-2.374-32.844-3.166-39.175 c-0.792-6.331-2.77-59.752-2.77-59.752L80.402,283.492z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M46.218,421.231 c0,0-15.084,2.914-18.855,4.114c-3.771,1.2-3.771,3.428-2.914,7.542c0.857,4.114,2.571,6.171,3.257,6.685 c0.686,0.514,1.2,7.028,3.085,11.142c1.886,4.114,6.171,12.341,10.113,14.398c3.942,2.057,8.228,2.057,8.742,1.371 c0.514-0.686-1.028-5.485-1.028-5.485l-3.942-12.684c0,0,4.628-12.513,5.314-13.198c0.686-0.686,4.114-4.285,4.114-4.285 L46.218,421.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M40.905,465.112 c3.942,2.057,8.228,2.057,8.742,1.371c0.149-0.199,0.122-0.748,0.013-1.421c-3.504-0.173-9.415-0.976-11.841-4.75 c-3.085-4.799-6.171-15.084-7.542-20.741c-1.068-4.405-2.239-11.406-2.706-14.29c-0.07,0.021-0.145,0.043-0.208,0.063 c-3.771,1.2-3.771,3.428-2.914,7.542c0.857,4.114,2.571,6.171,3.257,6.685c0.686,0.514,1.2,7.028,3.085,11.142 S36.962,463.055,40.905,465.112z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M95.834,287.845 c0,0,5.738,7.518,6.331,8.508c0.594,0.989,4.749,38.581,5.144,42.341c0.396,3.759,0,9.101,0,9.101s-13.913,13.877-23.014,25.155 c-9.101,11.278-38.718,47.721-38.718,47.721l12.974,20.243c0,0,16.25-13.043,27.897-24.138 c18.442-17.568,35.791-36.144,36.978-37.133c1.187-0.989,9.189-9.468,9.783-11.842c0.594-2.374,6.943-35.636,9.12-46.32 c2.176-10.684,5.144-39.571,5.144-39.571l-54.41,1.385"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M108.213,147.027c0,0-9.625,5.073-14.698,7.544c-5.073,2.471-21.982,7.544-23.673,10.276c-1.691,2.732-1.431,7.024-1.431,7.024 s-16.604,45.7-17.013,53.667c-0.409,7.967,1.226,53.317,1.226,53.317s1.226,1.839,7.763,1.634c6.537-0.204,9.193-1.43,9.193-1.43 s3.269-45.759,3.881-48.415c0.613-2.656,1.634-4.903,1.634-4.903l7.15-14.3c0,0,2.451,14.708,2.451,15.321 c0,0.613-13.483,55.769-13.483,55.769s0,3.677,23.901,6.946s44.738,5.311,45.759,5.311c1.021,0,6.537-9.193,6.537-9.193 s1.43,5.107,1.021,5.72c-0.409,0.613,4.086-1.021,5.107-1.839s4.086-3.268,4.086-3.268s-6.333-35.137-6.333-37.792 c0-2.656,1.634-12.257,1.634-12.257l23.697,43.308c0,0,0,0.613,5.72-2.656s8.58-6.537,8.58-6.537l-19.202-47.189 c0,0-4.494-52.092-4.903-54.747c-0.408-2.656,0.613-3.269-1.838-4.494c-2.451-1.226-13.712-3.55-13.712-3.55 s-18.533-7.107-25.494-9.235C118.811,148.932,108.213,147.027,108.213,147.027z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 82.245,211.442 75.504,175.284 78.364,218.388  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M113.841,196.711 c0.799,1.517,1.702,2.908,2.724,4.108"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M107.78,169.36 c0,0,0.414,14.762,5.096,25.352"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M104.716,181.209 c0,0,1.43,6.537,5.107,12.87"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M104.87,242.547 c8.459-2.106,20.212-4.985,25.177-5.978c8.171-1.634-11.235,0-11.235,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M95.319,244.945 c0,0,1.674-0.425,4.31-1.087"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M152.926,236.16 c0,0-4.699-7.763-5.107-9.601s-3.677-21.858-3.677-21.858s2.247,31.868,3.064,36.158c0.817,4.29,4.086,7.559,4.086,7.559 L152.926,236.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M142.09,195.998 c0.447,2.566,0.826,4.209,0.826,4.209"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M149.862,164.866 c0,0-7.967,2.043-8.988,12.053c-0.536,5.251,0.053,11.402,0.733,16.063"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M138.422,176.51 c0,0,0.204,7.967,2.043,14.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#969696",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M214.568,282.664c0,0-40.316,21.081-41.547,22.62c-1.231,1.539-0.462,4.001-0.154,5.078c0.308,1.077,10.002,40.624,11.233,41.239 c1.231,0.616,5.078-1.385,5.078-1.385s4.309,2.616,5.386,2.154c1.077-0.462,37.546-23.082,39.547-24.928 c2-1.846,1.847-3.231,1.231-4.616c-0.616-1.385-10.002-22.466-10.002-22.466s1.077-1.693,0.462-3.078 c-0.616-1.385-5.693-11.541-6.771-13.08C217.953,282.664,218.568,280.971,214.568,282.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M172.867,310.362c0.308,1.077,10.002,40.624,11.233,41.239c1.231,0.616,5.078-1.385,5.078-1.385s4.09,2.48,5.292,2.175 c-3.015-7.898-14.652-38.895-16.678-44.03c-1.722-4.363-3.529-3.928-4.336-3.426c-0.146,0.101-0.258,0.186-0.336,0.253 c-0.018,0.017-0.032,0.03-0.045,0.043c-0.019,0.019-0.042,0.039-0.053,0.054C171.79,306.823,172.559,309.284,172.867,310.362z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 185.177,
    y1: 326.211,
    x2: 224.416,
    y2: 301.591
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 203.335,312.67 206.104,317.44 210.105,314.516 207.489,310.054  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.51df6a00e41e85bac94670e4511700c3.svg";
export { ForwardRef as ReactComponent };